import { createUseStyles } from "react-jss";
import { down } from "../../../styles/breakpoints";

const useStyles = createUseStyles((_) => ({
  containerText: {
    padding: "19px 15px 29px 15px",
    display: "flex",
    flexDirection: "column",
    gap: "15px",
  },

  divCheckBox: {
    display: "flex",
    flexDirection: "row",
    gap: "10px",
    alignItems: "center",
  },

  containerForm: {
    display: "flex",
    flexDirection: "column",
    width: "100%",
    marginTop: "20px"
  },

  // Enhanced styles for images tab
  imagesContainer: {
    display: "flex",
    flexDirection: "column",
    gap: "30px",
    padding: "20px 0",
  },

  imageSection: {
    display: "flex",
    flexDirection: "column",
    gap: "15px",
  },

  imageSectionHeader: {
    display: "flex",
    flexDirection: "column",
    gap: "5px",
  },

  sectionTitle: {
    fontSize: "18px",
    fontWeight: "600",
    color: "#2c3e50",
    margin: "0",
  },

  sectionDescription: {
    fontSize: "14px",
    color: "#7f8c8d",
    fontStyle: "italic",
  },

  logoUploadContainer: {
    display: "flex",
    justifyContent: "center",
    alignItems: "center",
    maxWidth: "300px",
    margin: "0 auto",
  },

  galleryGrid: {
    display: "grid",
    gridTemplateColumns: "repeat(auto-fit, minmax(250px, 1fr))",
    gap: "20px",
    width: "100%",
  },

  galleryItem: {
    display: "flex",
    flexDirection: "column",
    gap: "10px",
  },

  galleryItemHeader: {
    display: "flex",
    justifyContent: "space-between",
    alignItems: "center",
    paddingBottom: "5px",
  },

  galleryItemTitle: {
    fontSize: "14px",
    fontWeight: "500",
    color: "#34495e",
  },

  removeImageBtn: {
    background: "#e74c3c",
    color: "white",
    border: "none",
    borderRadius: "50%",
    width: "24px",
    height: "24px",
    fontSize: "16px",
    fontWeight: "bold",
    cursor: "pointer",
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    transition: "all 0.2s ease",
    "&:hover": {
      background: "#c0392b",
      transform: "scale(1.1)",
    },
  },

  uploadGuidelines: {
    background: "#f8f9fa",
    border: "1px solid #e9ecef",
    borderRadius: "8px",
    padding: "20px",
    marginTop: "10px",
  },

  guidelinesTitle: {
    fontSize: "16px",
    fontWeight: "600",
    color: "#495057",
    margin: "0 0 15px 0",
  },

  guidelinesList: {
    margin: "0",
    paddingLeft: "20px",
    "& li": {
      fontSize: "14px",
      color: "#6c757d",
      marginBottom: "8px",
      lineHeight: "1.4",
      "&:last-child": {
        marginBottom: "0",
      },
    },
  },

  // Enhanced styles for horaires (hours) tab
  horaireContainer: {
    display: "flex",
    flexDirection: "column",
    gap: "25px",
    padding: "20px 0",
  },

  horaireSection: {
    background: "#ffffff",
    border: "1px solid #e1e8ed",
    borderRadius: "12px",
    padding: "24px",
    boxShadow: "0 2px 8px rgba(0, 0, 0, 0.06)",
    transition: "all 0.3s ease",
    "&:hover": {
      boxShadow: "0 4px 16px rgba(0, 0, 0, 0.1)",
      borderColor: "#3498db",
    },
  },

  horaireSectionHeader: {
    display: "flex",
    alignItems: "center",
    gap: "12px",
    marginBottom: "20px",
    paddingBottom: "15px",
    borderBottom: "2px solid #f8f9fa",
  },

  horaireIcon: {
    width: "24px",
    height: "24px",
    borderRadius: "6px",
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    fontSize: "14px",
    fontWeight: "bold",
    color: "white",
  },

  workingDaysIcon: {
    background: "linear-gradient(135deg, #27ae60, #2ecc71)",
  },

  unworkingDaysIcon: {
    background: "linear-gradient(135deg, #e74c3c, #c0392b)",
  },

  horaireSectionTitle: {
    fontSize: "18px",
    fontWeight: "600",
    color: "#2c3e50",
    margin: "0",
  },

  horaireSectionSubtitle: {
    fontSize: "13px",
    color: "#7f8c8d",
    fontWeight: "400",
    marginTop: "2px",
  },

  horaireInputWrapper: {
    background: "#f8f9fa",
    borderRadius: "8px",
    padding: "16px",
    border: "1px solid #e9ecef",
    transition: "all 0.2s ease",
    "&:focus-within": {
      borderColor: "#3498db",
      background: "#ffffff",
      boxShadow: "0 0 0 3px rgba(52, 152, 219, 0.1)",
    },
  },

  horaireLabel: {
    fontSize: "14px",
    fontWeight: "500",
    color: "#495057",
    marginBottom: "8px",
    display: "block",
  },

  horaireInputContainer: {
    position: "relative",
  },

  horaireEmptyState: {
    textAlign: "center",
    padding: "30px 20px",
    color: "#95a5a6",
    fontSize: "14px",
    fontStyle: "italic",
    background: "#f8f9fa",
    borderRadius: "8px",
    border: "2px dashed #bdc3c7",
  },

  horaireEmptyIcon: {
    fontSize: "32px",
    marginBottom: "10px",
    display: "block",
  },

  horaireHelperText: {
    fontSize: "12px",
    color: "#6c757d",
    marginTop: "8px",
    display: "flex",
    alignItems: "center",
    gap: "6px",
  },

  horaireHelperIcon: {
    fontSize: "14px",
    color: "#17a2b8",
  },

  // Enhanced working days display
  workingDaysList: {
    display: "flex",
    flexDirection: "column",
    gap: "12px",
  },

  workingDayItem: {
    display: "flex",
    alignItems: "center",
    justifyContent: "space-between",
    padding: "12px 16px",
    background: "#ffffff",
    border: "1px solid #e9ecef",
    borderRadius: "8px",
    transition: "all 0.2s ease",
    "&:hover": {
      borderColor: "#3498db",
      transform: "translateY(-1px)",
      boxShadow: "0 2px 8px rgba(0, 0, 0, 0.08)",
    },
  },

  workingDayName: {
    fontSize: "14px",
    fontWeight: "500",
    color: "#2c3e50",
    minWidth: "80px",
  },

  workingDayHours: {
    fontSize: "13px",
    color: "#7f8c8d",
    display: "flex",
    alignItems: "center",
    gap: "8px",
  },

  workingDayStatus: {
    padding: "4px 8px",
    borderRadius: "4px",
    fontSize: "11px",
    fontWeight: "500",
    textTransform: "uppercase",
    letterSpacing: "0.5px",
  },

  statusOpen: {
    background: "#d4edda",
    color: "#155724",
  },

  statusClosed: {
    background: "#f8d7da",
    color: "#721c24",
  },

  /*
   * These were `@media (max-width: 768px)` and `(max-width: 480px)`. 768 was a
   * one-off that matched nothing else in the app, so this dialog reflowed at a
   * different width from the page behind it; `down.md` (900) is the width at
   * which the sidebar and every other screen already switch. 480 maps exactly
   * onto the shared `down.xs`.
   */
  [down.md]: {
    galleryGrid: {
      gridTemplateColumns: "1fr",
    },
    
    logoUploadContainer: {
      maxWidth: "100%",
    },

    imagesContainer: {
      gap: "20px",
      padding: "15px 0",
    },

    horaireContainer: {
      gap: "20px",
      padding: "15px 0",
    },

    horaireSection: {
      padding: "20px 16px",
    },

    horaireSectionHeader: {
      marginBottom: "15px",
      paddingBottom: "12px",
    },

    horaireSectionTitle: {
      fontSize: "16px",
    },

    workingDayItem: {
      flexDirection: "column",
      alignItems: "flex-start",
      gap: "8px",
    },

    workingDayName: {
      minWidth: "auto",
    },
  },

  [down.xs]: {
    horaireSection: {
      padding: "16px 12px",
    },

    horaireSectionHeader: {
      flexDirection: "column",
      alignItems: "flex-start", 
      gap: "8px",
    },
  },
}));

export default useStyles;